import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import CommonModal from "../Common/Modals/CommonModal";
import { useHistory } from "react-router-dom";
import {
  Button,
  CircularProgress,
  Divider,
  Typography,
} from "@material-ui/core";
import HTMLReactParser from "html-react-parser";
import GetPageData from "../../hooks/GetPageData";
import LoadingComponet from "../Loading/LoadingComponet";

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("md")]: {
      backgroundColor: "white",
    },
  },
  content: {
    width: "90vw",
    maxHeight: "70vh",
    overflow: "auto",
    [theme.breakpoints.down("md")]: {
      width: "100%",
      maxHeight: "50vh",
    },
  },
  text: {
    fontSize: "1rem",
    [theme.breakpoints.down("md")]: {
      fontSize: "1rem",
    },
  },
  readmoreBtn: {
    borderRadius: 100,
  },
  btnContainer: {
    marginTop: theme.spacing(2),
    display: "flex",
    width: "100%",
    justifyContent: "flex-end",
    [theme.breakpoints.down("md")]: {
      marginTop: theme.spacing(2),
    },
  },
  loadingContainer: {
    // width: "90vw",
    height: "70vh",
    overflow: "auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    [theme.breakpoints.down("md")]: {
      width: "100%",
      height: "50vh",
    },
  },
}));

const SchemeModal = ({ open, onClose, title, id, type }) => {
  const classes = useStyles();
  const history = useHistory();

  const handleNavigate = (link, extenral, download, title) => {
    // if (download) {
    //   downloadURI(link, title);
    // }
    if (extenral) {
      return window.open(link, "_blank");
    }
    history.push(link);
  };

  const { ready, data, error } = GetPageData(`${type}ById/${id}`);
  return (
    <CommonModal open={open} onClose={onClose} title={title || "title"}>
      <div className={classes.content}>
        {ready && data ? (
          <Typography className={classes.text}>
            {data.data && HTMLReactParser(data.data)}
          </Typography>
        ) : (
          <div className={classes.loadingContainer}>
            <CircularProgress color="primary" size={50} />
          </div>
        )}
      </div>
      {data.link && (
        <>
          <Divider />

          <div className={classes.btnContainer}>
            <Button
              color="primary"
              variant="outlined"
              onClick={() =>
                handleNavigate(
                  data.link,
                  data.external,
                  data.download,
                  data.title
                )
              }
              className={classes.readmoreBtn}
            >
              {data.linkTitle}
            </Button>
          </div>
        </>
      )}
    </CommonModal>
  );
};
export default SchemeModal;
